import script from "./LauncherOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./LauncherOverlay.vue?vue&type=script&setup=true&lang=js"

import "./LauncherOverlay.vue?vue&type=style&index=0&id=ba5494de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba5494de"]])

export default __exports__